import { useState, useEffect } from 'react';

export function Carousel({ images = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  useEffect(() => {
    if (!isAutoPlay || images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [isAutoPlay, images.length]);

  const goToImage = (index) => {
    setCurrentIndex(index);
    setIsAutoPlay(false);
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    setIsAutoPlay(false);
  };

  const getImageSrc = (image) => {
    return typeof image === 'string' ? image : image.src;
  };

  if (images.length === 0) return null;

  return (
    <div className="carousel-container">
      <div className="carousel-slide-wrapper">
        {images.map((image, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
            style={{
              backgroundImage: `url("${getImageSrc(image)}")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        ))}
      </div>

      <div className="carousel-dots">
        {images.length > 0 && Array.from({ length: Math.min(5, images.length) }).map((_, index) => {
          const pageSize = Math.ceil(images.length / 5);
          const isActive = Math.floor(currentIndex / pageSize) === index;
          return (
            <button
              key={index}
              className={`carousel-dot ${isActive ? 'active' : ''}`}
              onClick={() => goToImage(index * pageSize)}
              aria-label={`Go to group ${index + 1}`}
            />
          );
        })}
      </div>

      {images.length > 1 && (
        <div className="carousel-controls">
          <button
            className="carousel-nav carousel-prev"
            onClick={() => {
              setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
              setIsAutoPlay(false);
            }}
            aria-label="Previous image"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          <button
            className="carousel-nav carousel-next"
            onClick={nextImage}
            aria-label="Next image"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
